import { render } from "./text-label.component.vue?vue&type=template&id=0c6167e8"
import script from "./text-label.component.vue?vue&type=script&lang=js"
export * from "./text-label.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./text-label.component.vue?vue&type=style&index=0&id=0c6167e8&lang=css&module=true"
cssModules["$style"] = style0

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__